








import Vue from 'vue';

export default Vue.extend({
    name: 'PasswordCriteria',
    props: {
        criteriaText: {
            type: String,
            required: true,
        },
        criteriaFulfilled: {
            type: Boolean,
            required: true,
        },
    },
});
